module.exports = __webpack_public_path__ + "bd9099cf60efe1368000f245b56d97a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/images_en/home_25.jpg
// module id = 1130
// module chunks = 0